import { ApiClient } from '@brent/shared/api'
import { userPool } from './cognito'

/**
 * Admin portal API client instance
 * Uses shared ApiClient from @brent/shared for consistent authentication and error handling
 */
const apiClient = new ApiClient({
  baseUrl: import.meta.env.VITE_ADMIN_API_BASE_URL,
  timeout: 30000, // 30 seconds - allow margin beyond Lambda timeout
  userPool,
  onUnauthorized: () => {
    // Redirect to login page on 401
    window.location.href = '/login'
  },
})

export default apiClient
